import React from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../components/Footer';

const GizlilikPolitikasi = () => {
  return (
    <>
      <Helmet>
        <title>Gizlilik ve Çerez Politikası - SigortamOlsun</title>
        <meta name="description" content="SigortamOlsun Gizlilik ve Çerez Politikası" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-6">
              Gizlilik ve Çerez Politikası
            </h1>

            <div className="prose prose-blue max-w-none">
              <div className="bg-gray-50 p-6 rounded-lg mb-8">
                <p className="text-gray-600">
                  SigortamOlsun olarak web sitemizi ziyaret eden ve bizimle elektronik olarak iletişim kuran herkesin 
                  kişisel verilerine saygı gösteriyoruz. Web sitemizin ziyaret edilmesi sırasında otomatik veya otomatik 
                  olmayan yöntemlerle kaydettiğimiz ve elektronik olarak bizimle paylaştığınız kişisel verileriniz, 
                  öncelikle taleplerinizin yerine getirilmesini temin edebilmek, daha sonra ise size daha iyi hizmet 
                  sunmak amacıyla kullanılacaktır.
                </p>
              </div>

              <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
                Kişisel Verilerin Korunması İlkelerimiz
              </h2>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Kişisel verileriniz, her zaman hukuka ve dürüstlük kuralına uygun, doğru bir biçimde işlenecektir.</li>
                <li>Kişisel verileriniz, belirli, açık ve meşru amaçlar için işlenebilecektir.</li>
                <li>Kişisel verileriniz, amaçlarla sınırlı ve bağlantılı olarak toplanacak ve ölçülü biçimde işlenecektir.</li>
                <li>Kişisel verileriniz işlendikleri amaç için gerekli olan süre kadar muhafaza edilecektir.</li>
              </ul>

              <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
                Çerez (Cookie) Politikamız
              </h2>
              
              <div className="space-y-6">
                <div className="bg-white p-6 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-800 mb-3">Çerez Nedir?</h3>
                  <p className="text-gray-600">
                    Çerezler, ziyaret ettiğiniz web siteleri tarafından oluşturulan ve web sitesi tercihleriniz veya profil 
                    bilgileriniz gibi göz atma bilgilerini saklayan ve cihazınıza yerleştirilen küçük metin dosyalarıdır.
                  </p>
                </div>

                <div className="bg-white p-6 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-800 mb-3">Kullandığımız Çerez Tipleri</h3>
                  <div className="space-y-4">
                    <div>
                      <h4 className="font-medium text-gray-700">1. Gerekli Çerezler</h4>
                      <p className="text-gray-600">Web sitemizde gezinti yapmanıza ve temel özellikleri kullanmanıza olanak tanır.</p>
                    </div>
                    <div>
                      <h4 className="font-medium text-gray-700">2. Kişiselleştirme Çerezleri</h4>
                      <p className="text-gray-600">Sizin için kişiselleştirilmiş bir deneyim sunmamıza yardımcı olur.</p>
                    </div>
                    <div>
                      <h4 className="font-medium text-gray-700">3. Analitik Çerezler</h4>
                      <p className="text-gray-600">Web sitemizin kullanımını analiz etmek ve iyileştirmeler yapmak için kullanılır.</p>
                    </div>
                    <div>
                      <h4 className="font-medium text-gray-700">4. Ticari Çerezler</h4>
                      <p className="text-gray-600">Kişiselleştirilmiş reklamları göstermek için kullanılır.</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-800 mb-3">Çerez Tercihleri</h3>
                  <p className="text-gray-600">
                    Çerezlerin kullanımına ilişkin tercihlerinizi değiştirmek ya da çerezleri engellemek veya silmek için 
                    tarayıcınızın ayarlarını değiştirebilirsiniz. Ancak bu durumda sitenin tüm özelliklerinden 
                    faydalanamayabileceğinizi hatırlatmak isteriz.
                  </p>
                </div>
              </div>

              <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
                Kişisel Verilerin Paylaşılması
              </h2>
              <p className="text-gray-600 mb-4">
                Kişisel verileriniz, rızanız olmaksızın üçüncü kişilerle paylaşılmayacaktır. Ancak yasal yükümlülüklerimiz 
                kapsamında ve hizmet kalitemizi artırmak amacıyla, belirli durumlarda ve gerekli güvenlik önlemleri alınarak 
                hizmet sağlayıcılarımızla paylaşılabilir.
              </p>

              <div className="bg-blue-50 p-6 rounded-lg mt-8">
                <h2 className="text-xl font-semibold text-blue-800 mb-4">
                  İletişim ve Tercihleriniz
                </h2>
                <p className="text-gray-700 mb-4">
                  E-bülten aboneliğinizi sonlandırmak veya veri işleme tercihlerinizi değiştirmek için aşağıdaki kanalları 
                  kullanabilirsiniz:
                </p>
                <ul className="text-gray-700 space-y-2">
                  <li>E-posta: info@sigortamolsun.com</li>
                  <li>Web: www.sigortamolsun.com</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default GizlilikPolitikasi;